import { Box, Image, SimpleGrid, Text, VStack } from '@chakra-ui/react'
import { serverSidePropsWithAuth } from 'auth/components/context'
import Footer from 'common/footer'
import { Institutional } from 'common/institutional'
import { Section } from 'common/section'
import { Appbar } from 'layout/appbar'
import Head from 'next/head'
import { addCdn } from 'utils/env'

const AboutUsScreen = () => {
  return (
    <VStack w='full'>
      <Head>
        <title>Berrytech - Quem Somos</title>
      </Head>
      <Appbar />
      <VStack
        p={[5, 20]}
        pb={12}
        textAlign={'center'}
        maxW={'container.lg'}
        spacing={8}
      >
        <Text textStyle={'title'}>
          Jovens, sinceros, pragmáticos e divertidos
        </Text>
        <Text>
          Como dizia Steve Jobs: os loucos que acham que podem mudar o mundo,
          são os que efetivamente o fazem. Não sei o quanto vamos mudar o mundo,
          mas estamos aqui para mudar o Brasil, uma empresa de cada vez.
        </Text>
      </VStack>
      <Image
        w={'full'}
        alt={'Equipe Berrytech'}
        src={addCdn('/images/berrytech/team.png')}
      />
      <Section mt={'-150px'}>
        <SimpleGrid columns={[1]} spacing={12}>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'title'}>Propósito</Text>
            <Text>
              Transformar o Brasil em um país melhor e mais empreendedor
            </Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'title'}>Missão</Text>
            <Text>
              Gerar constante transformação nos empresários e suas empresas
              através de treinamento, suporte e relacionamento humano
            </Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'title'}>Visão</Text>
            <Text>
              Tornar-se a maior e mais impactante aceleradora de empresas do
              Brasil e criar uma nova era de desenvolvimento, crescimento e
              produtividade
            </Text>
          </VStack>
        </SimpleGrid>
        <Box h={12} />
        <Text textStyle={'subtitle'} textAlign={'center'}>
          Valores
        </Text>
        <SimpleGrid columns={[1, 2]} spacing={10}>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'h1'}>Obsessão pelo cliente</Text>
            <Text>
              Conexão, empatia, flexibilidade e esforço constante para
              transformar a vida e empresas de nossos clientes
            </Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'h1'}>Responsabilidade</Text>
            <Text>
              As decisões devem levar em consideração o seu impacto na empresa e
              na qualidade de vida de seus integrantes
            </Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'h1'}>Criatividade e simplicidade</Text>
            <Text>
              Quando problemas complexos surgem a solução mais simples e
              elegante maximiza a probabilidade de sucesso
            </Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'h1'}>Melhoria e aprendizado constante</Text>
            <Text>Amamos aprender, mudar e inovar, está em nosso DNA</Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'h1'}>Os melhores produtos e serviços</Text>
            <Text>
              Nada substitui o prazer de criar excelentes soluções para
              problemas complexos
            </Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'h1'}>Pensar grande</Text>
            <Text>
              Consideramos esse valor a base de toda a energia da empresa e seus
              integrantes, frases malucas é o que não falta
            </Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'h1'}>Ação é imprescindível</Text>
            <Text>
              Aqui não existe planejamento sem execução, e feito é melhor que
              perfeito
            </Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'h1'}>Frugalidade</Text>
            <Text>
              Acreditamos no esforço de tentar alcançar mais cuidando dos
              recursos
            </Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'h1'}>Confiança</Text>
            <Text>
              Tratar a todos com respeito e seguir a missão e visão da empresa.
              Confiança é o que mantém os clientes fiéis à sua marca, os
              colaboradores felizes com a empresa e é o que mantém as pessoas
              juntas
            </Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'h1'}>Os dados contêm a verdade</Text>
            <Text>
              Quando estamos em dúvida de qual decisão tomar, olhamos para os
              dados como um guia para explicar o passado e construir o futuro
            </Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'h1'}>Discordar, mas se comprometer</Text>
            <Text>
              Nem sempre todos concordamos nas decisões, mas uma vez que algo é
              acordado, todos participam ativamente para que a decisão tomada
              seja bem sucedida
            </Text>
          </VStack>
          <VStack w={'full'} align={'flex-start'}>
            <Text textStyle={'h1'}>Sempre entregar resultados</Text>
            <Text>
              Ao final do dia, queremos ter aquela sensação de que o nosso
              trabalho fez diferença
            </Text>
          </VStack>
        </SimpleGrid>
        <VStack>
          <Text textStyle={'subtitle'}>Como isso se aplica no dia-a-dia</Text>
          <Box h={8} />
          <VStack spacing={1} w={'full'} align={'flex-start'}>
            <li>
              O cliente está no centro, nos importamos verdadeiramente com ele e
              auxiliamos o cliente em todas as etapas
            </li>
            <li>
              Por mais inconveniente que o cliente seja, sempre somos honestos,
              transparentes e respeitosos
            </li>
            <li>
              Não somos uma família, somos um time focado e de alto desempenho,
              por isso não toleramos resultados medíocres
            </li>
            <li>Acreditamos que juntos chegamos mais longe</li>
            <li>Nunca paramos de aprender</li>
            <li>
              A técnica qualquer um aprende, caráter e vontade de aprender é o
              que buscamos
            </li>
            <li>
              Todos do time tem que trabalhar para o crescimento da empresa e o
              alcance do nosso propósito
            </li>
            <li>O que é acordado, deve ser cumprido</li>
            <li>Não perguntamos aquilo que o Google responde</li>
            <li>
              Entregamos o que era esperado e aquilo que precisava ser feito
            </li>
            <li>Somos competitivos e gostamos de desafios</li>
            <li>
              Nos divertimos muito, mas sempre fazemos o precisa ser feito
            </li>
            <li>Não terceirizamos as responsabilidades</li>
            <li>
              Somos otimistas e temos iniciativa para resolver os problemas
            </li>
            <li>Somos auto-motivados</li>
            <li>Simplificamos e fazemos perguntas diante dos desafios</li>
            <li>Discordamos mas nos comprometemos em fazer dar certo</li>
            <li>Só fazemos reuniões produtivas</li>
            <li>Não temos medo das mudanças</li>
            <li>Nos vestimos como queremos ser vistos</li>
            <li>Temos visão de longo prazo</li>
            <li>
              Respeitamos e ouvimos a todos, mas a decisão sempre estará
              conectado ao propósito
            </li>
          </VStack>
        </VStack>
      </Section>
      <Institutional />
      <Footer />
    </VStack>
  )
}

export const getServerSideProps = serverSidePropsWithAuth

export default AboutUsScreen
